<template>
  <div class="editMyInvo">
    <div class="print01" >
        <div><img src="../../../assets/img/logoBlue.png" width="179" /></div>
        <div class="marTop20">
          <a class="blueBtnW" @click="clkPrint">Print</a>
          <a class="blueBtnW" @click="clkExport">Export</a>
        </div>
    </div>
    
    <!--我的发票预览  start-->
     <table id="table-content" bordercolor="#e6e6e6" border="1" cellspacing="0" cellpadding="0" width="100%" class="tableInvo marTop20" style="page-break-after:always;width:210mm">
        <colgroup>
          <col width="16%">
          <col width="14%">
          <col width="14%">
          <col width="14%">
          <col width="12%">
          <col width="14%">
          <col>
        </colgroup>
        <tbody>
          <!-- 发票基本资料 start -->
        <tr>
          <th colspan="7" align="center" style="padding:10px 0"><h2>COMMERCIAL INVOICE</h2></th>
        </tr>
        <tr>
          <th align="right" bgcolor="#F8FAFC">Invoice No.</th>
          <td align="left" colspan="3">{{fromInvoInfo.InvoiceNo}}</td>
          <th align="right" bgcolor="#F8FAFC">Date</th>
          <td align="left" colspan="2">{{new Date(fromInvoInfo.DateofExportation).Format('yyyy-MM-dd')}}</td>
        </tr>
        <tr>
          <th align="right" bgcolor="#F8FAFC">Country of Origin</th>
          <td align="left" colspan="3">{{fromInvoInfo.originalCountry}}</td>
          <th align="right" bgcolor="#F8FAFC">Freightshop No.</th>
          <td align="left" colspan="2">{{fromInvoInfo.WaybillNO}}</td>
        </tr>
        <!-- 发票基本资料 end -->
        <!-- 发件人信息 start -->
        <tr>
          <th colspan="7" align="left" style="padding:10px"><h3>Consignor Information</h3></th>
        </tr>
        <tr>
          <th align="right" bgcolor="#F8FAFC">Company</th>
          <td align="left" colspan="6">{{fromInvoInfo.shipperCompany}}</td>              
        </tr>
        <tr>
          <th align="right" bgcolor="#F8FAFC">Contact</th>
          <td align="left" colspan="3">{{fromInvoInfo.shipperContact}}</td>
          <th align="right" bgcolor="#F8FAFC">Tel.</th>
          <td align="left" colspan="2">&nbsp;{{fromInvoInfo.shipperTEL}}</td>
        </tr>
        <tr>
          <th align="right" bgcolor="#F8FAFC">Add.</th>
          <td align="left" colspan="6">
            {{fromInvoInfo.shipperAddr}}, {{fromInvoInfo.shipperCity}}, {{fromInvoInfo.shipperProv}}
          </td>
        </tr>
        <!-- 发件人信息 end -->
        <!-- 收件人信息 start -->
        <tr>
          <th colspan="7" align="left" style="padding:10px"><h3>Consignee Information</h3></th>
        </tr>
        <tr>
          <th align="right" bgcolor="#F8FAFC">Company</th>
          <td align="left" colspan="6">{{fromInvoInfo.consigCompany}}</td>              
        </tr>
        <tr>
          <th align="right" bgcolor="#F8FAFC">Contact</th>
          <td align="left" colspan="3">{{fromInvoInfo.consigContact}}</td>
          <th align="right" bgcolor="#F8FAFC">Tel.</th>
          <td align="left" colspan="2">&nbsp;{{fromInvoInfo.consigTEL}}</td>
        </tr>
        <tr>
          <th align="right" bgcolor="#F8FAFC">Country</th>
          <td align="left" colspan="3">{{fromInvoInfo.consigCountry}}</td>
          <th align="right" bgcolor="#F8FAFC">Zip Code</th>
          <td align="left" colspan="2">&nbsp;{{fromInvoInfo.consigZipCode}}</td>
        </tr>
        <tr>
          <th align="right" bgcolor="#F8FAFC">Add.</th>
          <td align="left" colspan="6">{{fromInvoInfo.consigAddr}}, City:{{fromInvoInfo.consigCity}}</td>
        </tr>
        <!-- 收件人信息 end -->

        <!-- 产品信息 start -->
        <tr>
          <th bgcolor="#F8FAFC" align="center">Commodity</th>
          <th bgcolor="#F8FAFC" align="center">Material</th>
          <th bgcolor="#F8FAFC" align="center">Use</th>
          <th bgcolor="#F8FAFC" align="center">HS Code</th>
          <th bgcolor="#F8FAFC" align="center">Qty</th>
          <th bgcolor="#F8FAFC" align="center">Unit Price</th>
          <th bgcolor="#F8FAFC" align="center">Total Price</th>
        </tr>
        <tr class="goodsList" v-for="(item,index) in fromInvoInfo.goodsInfoList" :key="index">
          <td align="center">{{item.Commodity}}</td>
          <td align="center">{{item.Material}}</td>
          <td align="center">{{item.Use}}</td>
          <td align="center">{{item.HSCode}}</td>
          <td align="center">{{item.Qty}}{{turnUnit(item.Unit)}} </td>              
          <td align="center">USD&nbsp; {{Number(item.UnitPrice).toFixed(2)}}</td>
          <td align="center">
            <p v-if="Number(item.Qty) && Number(item.UnitPrice)">USD&nbsp;{{(item.Qty * item.UnitPrice).toFixed(2)}}</p>
            <p v-else></p>
          </td>
        </tr>
        <tr>
          <td colspan="6" bgcolor="#F8FAFC" align="right"><b>Total Value</b></td>
          <td align="center">
            <p v-if="Number(totalValue)" class="colRed"><b>USD&nbsp;{{totalValue.toFixed(2)}}</b></p>
            <p v-else></p>
          </td>
        </tr>
        <!-- 产品信息 end -->
        <tr>
          <td colspan="7" align="center" style="padding:10px 0;"><h3>SHIPPER’S SIGNATURE & STAMP:</h3></td>
        </tr>
        </tbody>              
      </table>  
      <!-- <div id="print02" class="footerBot">
        <p>© Copyright 2019, Shenzhen Freightshop Technology Co., Ltd. All rights reserved</p>
      </div> -->
      <div class="frameBg" v-show="showModal"></div>
    <div class="frameInput2" v-if="showChooseBox">
          <div class="frameHead indexHead clear">
            <p class="l">Export invoice</p><p @click="getClose" class="r" style="font-size:26px;">×</p>
          </div>
          <div class="content"> 
            <div style="margin:120px auto 0;text-align:center">
              <el-radio v-model="radio" :label="1">PDF</el-radio>
              <el-radio v-model="radio" :label="2">Excel</el-radio>
            </div>       
         </div>
          <div class="framePwBtn">
              <a style="margin-left:32%;" class="sureLineA l" @click="getClose">Cancel</a>
              <a id="print-click" class="sureA l marL10" @click="invoConfirmBtn">Confirm</a>
          </div>  
      </div>
  </div>
  
</template>

<script>
import Vue from "vue";
import { post, fetch, Del, put } from "../../../ask/axios";
export default {
  components: {},
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      showModal:false,//弹框遮罩层
      showChooseBox:false, //选择导出模式
      radio:1,

       //我的发票inupt输入框
      fromInvoInfo:{
        InvoiceNo:'',//我的发票
        DateofExportation:'',
        originalCountry:'China',//原产地
        WaybillNO:'',
        //发件人信息
        shipperCompany:'',
        shipperContact:'',
        shipperTEL:'',shipperAddr:'',shipperProv:'',shipperCity:'',
        chCityOptions:[],//中国城市数据

        //收件人信息
        consigCompany:'',consigContact:'',consigTEL:'',consigCountry:'',consigZipCode:'',consigAddr:'',consigCity:'',consigIsDefault:false,
        countryOptions:[], //海外国家数据
        cityOptions:[],//海外城市数据
        
        //产品信息
        goodsInfoList:[
          {Commodity:'',Material:'',Use:'',HSCode:'',Qty:'',UnitPrice:'',Unit:1}         
        ], 
      }, 
    };
  },

  created() {
    this.getInvoicePreviewInfo();
 
  },
  mounted() {
    //console.log('message222  ' + JSON.stringify(this.ConsigDefaultMsg) )
   
  },
  watch: {
    
  },
  computed: {//计算属性周期函数
  //产品信息总申报价值计算
  totalValue(){
    //        return this.fromInvoInfo.goodsInfoList.map(
    //          row=>row.quantity*row.unitValue).reduce(
    //          (acc, cur) => (parseFloat(cur) + acc), 0)
    let num = 0
    if (this.fromInvoInfo.goodsInfoList) {
      this.fromInvoInfo.goodsInfoList.forEach(e => {
        num += e.Qty * e.UnitPrice
      })
      return num
    }
  },
  },
  methods: { 
    //预览发票取值
    getInvoicePreviewInfo(){
        let that=this
        that.api.param={
          //id:invoiceId
        }
        // that.api.url=that.$api02 + '/api/EbayCustomer/MyInvoice/GetDetial/'+this.$route.query.CusInvoiceID;
        that.api.url=that.$api04 + '/Basics/api/MyInvoice/GetDetial/'+this.$route.query.CusInvoiceID;
        fetch(that.api.url,that.api.param).then(function (res) {
          if(res.Results){

            that.fromInvoInfo.InvoiceNo=res.Results.InvoiceNO
            that.fromInvoInfo.DateofExportation=res.Results.DateofExportation
            that.fromInvoInfo.originalCountry=res.Results.CountryofOrigin
            that.fromInvoInfo.WaybillNO=res.Results.WaybillNO

            //发件人信息
            that.fromInvoInfo.shipperCompany=res.Results.ConsignorCompany 
            that.fromInvoInfo.shipperContact=res.Results.ConsignorName 
            that.fromInvoInfo.shipperTEL=res.Results.ConsignorTel 
            that.fromInvoInfo.shipperAddr=res.Results.ConsignorStreet 
            that.fromInvoInfo.shipperProv=res.Results.ConsignorProv 
            that.fromInvoInfo.shipperProvKey=res.Results.ConsignorProvKey 
            that.fromInvoInfo.shipperCity=res.Results.ConsignorCity 
            that.fromInvoInfo.shipperCity_Key=res.Results.ConsignorCityKey 

            //收件人信息
            that.fromInvoInfo.consigCompany=res.Results.ConsigneeCompany  
            that.fromInvoInfo.consigContact=res.Results.ConsigneeName   
            that.fromInvoInfo.consigTEL=res.Results.ConsigneeTel  
            that.fromInvoInfo.consigCountry=res.Results.ConsigneeCountry  
            that.fromInvoInfo.Country_Key=res.Results.ConsigneeCountryKey  
            that.fromInvoInfo.shipperProvKey=res.Results.ConsignorProvKey 
            that.fromInvoInfo.consigZipCode=res.Results.ConsigneeZipCode  
            that.fromInvoInfo.consigAddr=res.Results.ConsigneeStreet  
            that.fromInvoInfo.consigCity=res.Results.ConsigneeCity 
            //产品信息
            let goodsInfo=[]
            res.Results.ProductInfos.forEach(e =>{
              let arrInfo={
              Commodity:e.EnglishName, 
              Material:e.Material, 
              Use:e.Purpose, 
              HSCode:e.CustomsCode, 
              Qty:e.Quanlity, 
              UnitPrice:e.Price, 
              Unit:e.Unit,
              }
              goodsInfo.push(arrInfo)
            })
            that.fromInvoInfo.goodsInfoList=goodsInfo

          }
        })
      }, 
        
    
    //弹框关闭
    getClose(){
      this.showModal=false;
      this.showChooseBox=false;
    },
      //打印
      clkPrint(){
        window.print();
        return false;
        // var newWindow;
        // //打开一个新的窗口
        // newWindow = window.open();
        // // 是新窗口获得焦点
        // newWindow.focus();
        // //保存写入内容
        // var newContent = "<html><head><meta charset='utf-8'/><title>Print</title></head><body>"
        // newContent += document.getElementById("table-content").outerHTML;
        // newContent += "</body></html>"
        // // 将HTML代码写入新窗口中
        // newWindow.document.write(newContent);
        // newWindow.print();
        // // close layout stream
        // newWindow.document.close();
        // //关闭打开的临时窗口
        // newWindow.close();
        // return false;
      },
     //选择导出方式
      clkExport(){
        this.showModal=true
        this.showChooseBox=true
      },
      //确定导出方式
      invoConfirmBtn(){
        if(this.radio==1){
          //this.getPdf('table-content', '我的发票.pdf')
           this.getPdf('table-content', "My Invoice-"+ this.fromInvoInfo.InvoiceNo +"-"+ new Date().Format('yyyyMMdd') +".pdf")
        }else if(this.radio==2){
          this.exportToExcel();
        }
        this.showModal=false,
        this.showChooseBox=false
      }, 
    
    //excel导出
     exportToExcel(){
        // 使用outerHTML属性获取整个table元素的HTML代码（包括<table>标签），然后包装成一个完整的HTML文档，设置charset为urf-8以防止中文乱码
        var html = "<html><head><meta charset='utf-8' /></head><body>" + document.getElementById("table-content").outerHTML + "</body></html>";
        // 实例化一个Blob对象，其构造函数的第一个参数是包含文件内容的数组，第二个参数是包含文件类型属性的对象
        // var blob = new Blob([html], {
        //   type: "application/vnd.ms-excel"
        // });

       var blob = new Blob([html], { type: 'application/vnd.ms-excel' });
        //如果是IE
        if (window.navigator && window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, "My Invoice-"+ this.fromInvoInfo.InvoiceNo +"-"+ new Date().Format('yyyyMMdd') +".xls");
        }else{
        //不是IE  for Non-IE (chrome, firefox etc.)
        var a = document.getElementById("print-click");
        // 利用URL.createObjectURL()方法为a元素生成blob URL
        a.href = URL.createObjectURL(blob);
        // 设置文件名，目前只有Chrome和FireFox支持此属性
        a.download = "My Invoice-"+ this.fromInvoInfo.InvoiceNo +"-"+ new Date().Format('yyyyMMdd') +".xls";
        }
      }, 

       turnUnit(val){
        //<!--turnUnit {val:1,label:'PCS'},{val:2,label:'SET'},{val:3,label:'PKG'},{val:4,label:'KGS'},{val:5,label:'UNIT'} -->
        if(val==1 || !val) return 'PCS';
        if(val==2) return 'SET';
        if(val==3) return 'PKG';
        if(val==4) return 'KGS';
        if(val==5) return 'UNIT';
      },

  }
};

</script>
 <style>
  /*局部修改elementUI样式*/
  /*!*取消按钮*!*/
  /*.el-message-box__wrapper .btn-custom-cancel {float:right;margin:0 120px 0 0 !important;;}*/
  /*!*确定或者删除按钮*!*/
  /*.el-message-box__wrapper .el-message-box__btns button:nth-child(2){margin:0 0 0 120px !important;}*/
  @import "../../../assets/css/tipsMessage.css";
</style>
<style scoped>
  @import "../../../assets/css/userCenterCss.css";
  @import "../../../assets/css/frame.css";

   @page {margin: 0; } /* 去掉页眉页脚 */
 @media print{ /* 不打印区域 */
    .print01{display:none;}   
}

.editMyInvo{padding:5px 20px 20px;background:white;width:210mm;}
.tableInvo{width:100%;font-size:14px;border:1px solid #eaeaea;height:100%;}
.tableInvo tr th{font-size:12px;color:#333;border:1px solid #eaeaea;padding:8px 7px;}
.tableInvo tr td{font-size:12px;color:#666;padding:5px;line-height:26px;word-break:break-all;color:#000;border:1px solid #eaeaea;}

.footerBot{text-align:center;padding:20px 0;border-top:1px solid #ddd;margin:30px -50px 0;}

</style>



// WEBPACK FOOTER //
// src/components/userCenter/myInfo/CommonInvoicePreview.vue